import { useCallback, useState } from 'react';

import { Sort } from '@vimeo/comments-ui';
import useLocalStorage from '@vimeo/core/hooks/use-storage/useLocalStorage';

/**
 * Hook to handle storing and retrieving the users's sort preference from local storage.
 */
export const useSortPreference = (defaultSort: Sort, sortKey: string) => {
  const [localStorage, setLocalStorage] = useLocalStorage<Sort>(sortKey, defaultSort);
  const [sort, setSort] = useState<Sort>(localStorage);

  const updateSort = useCallback(
    (value: Sort) => {
      setSort(value);
      setLocalStorage(value);
    },
    [setLocalStorage],
  );

  return [sort, updateSort] as const;
};
